import { createRouter, createWebHashHistory } from 'vue-router'

// 引入页面
import Index from '../views/IndexPage.vue'
import Product from '../views/product/ProductsPage.vue'
import Job from '../views/JobPage.vue'
import Jobgw from '../views/JobgwPage.vue'
import Search from '../views/SearchPage.vue'
import About from '../views/about/AboutPage.vue'
import Corporate from '../views/about/CorporatePage.vue'
import Team from '../views/about/TeamPage.vue'
import News from '../views/news/NewsPage.vue'
import Detail from '../views/news/DetailPage.vue'
import ProductDetail from '../views/product/ProductDetailPage.vue'
import Case from '../views/service/CasePage.vue'
import CaseDetail from '../views/service/CaseDetailPage.vue'
import CaseVideo from '../views/service/CaseVideoPage.vue'
import RelatedCase from '../views/service/RelatedCasePage.vue'
import Service from '../views/service/ServicePage.vue'
import Digitize from '../views/DigitizePage.vue'


//定义路由
const routes = [
  { path: "/", redirect: "/IndexPage" },
  {
    path: "/IndexPage",
    name: "IndexPage",
    component: Index
  },
  {
    path: "/ProductPage",
    name: "ProductPage",
    component: Product
  },
  {
    path: "/AboutPage",
    name: "AboutPage",
    component: About
  },
  {
    path: "/CorporatePage",
    name: "CorporatePage",
    component: Corporate
  },
  {
    path: "/TeamPage",
    name: "TeamPage",
    component: Team
  },
  {
    path: "/JobPage",
    name: "JobPage",
    component: Job
  },
  {
    path: "/JobgwPage",
    name: "JobgwPage",
    component: Jobgw
  },
  {
    path: "/SearchPage",
    name: "SearchPage",
    component: Search
  },
  {
    path: "/NewsPage",
    name: "NewsPage",
    component: News
  },
  {
    path: "/DetailPage",
    name: "DetailPage",
    component: Detail
  },
  {
    path: "/ProductDetailPage",
    name: "ProductDetailPage",
    component: ProductDetail
  },
  {
    path: "/CasePage",
    name: "CasePage",
    component: Case
  },
  {
    path: "/CaseVideoPage",
    name: "CaseVideoPage",
    component: CaseVideo
  },
  {
    path: "/RelatedCasePage",
    name: "RelatedCasePage",
    component: RelatedCase
  },
  {
    path: "/CaseDetailPage",
    name: "CaseDetailPage",
    component: CaseDetail
  },
  {
    path: "/ServicePage",
    name: "ServicePage",
    component: Service
  },
  {
    path: "/DigitizePage",
    name: "DigitizePage",
    component: Digitize
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
})
export default router